const signinChapterData = () => {
    let chapterData;
    try {
        chapterData = JSON.parse(
            window.dazn.features.getVariableStringAnonymous(
                'f_ar_lp_chapterdata',
                'signinChapterDataV1'
            )
        );
        return chapterData;
    } catch (error) {
        return {};
    }
};

const signinChapterPath = window.dazn.features.getVariableStringAnonymous(
    'f_ar_lp_chapterdata',
    'signinChapterPath'
);

const exploreChapterData = () => {
    let chapterData;
    try {
        chapterData = JSON.parse(
            window.dazn.features.getVariableStringAnonymous(
                'f_ar_lp_chapterdata',
                'exploreChapterDataV1'
            )
        );
        return chapterData;
    } catch (error) {
        return {};
    }
};

const exploreChapterPath = window.dazn.features.getVariableStringAnonymous(
    'f_ar_lp_chapterdata',
    'exploreChapterPath'
);

const shouldSuperImpose = () =>
    window.dazn.features.getVariableBooleanAnonymous(
        'f_unified_landingpage_web',
        'shouldSuperImpose'
    );

const isPayopsOfferDetails = () =>
    window.dazn.features.isEnabledAnonymous('f_ar_payops_promo') ?? false;

const getpayopsOfferDetails = () => {
    let offerdetails = [];
    try {
        offerdetails = JSON.parse(
            window.dazn.features.getVariableStringAnonymous(
                'f_ar_payops_promo',
                'OfferPrice'
            )
        );
    } catch (error) {
        console.error('Error parsing offer details:', error);
    }
    return offerdetails;
};

export const hasBillingRouting = () =>
    window.dazn.features.isEnabledAnonymous('f_ar_billing_routing') ?? false;

export const showSeeMorePlansUi = () => {
    try {
        return (
            JSON.parse(
                window.dazn.features.getVariableBooleanAnonymous(
                    'f_ar_unified_signup_flow_newTierUi',
                    'showSeeMorePlansUi'
                )
            ) ?? true
        );
    } catch (error) {
        console.error('Error parsing offer details:', error);
        return true;
    }
};

export const getHideComponents = () => {
    let hideComponents;
    try {
        hideComponents = JSON.parse(
            window.dazn.features.getVariableStringAnonymous(
                'f_unified_landingpage_web',
                'hideComponents'
            )
        );
        return hideComponents;
    } catch (error) {
        return [];
    }
};

let isPPVDiscountOfferEnabled: boolean;
export const checkIsPPVDiscountOfferEnabled = () => {
    if (isPPVDiscountOfferEnabled !== undefined) {
        return isPPVDiscountOfferEnabled;
    }
    try {
        isPPVDiscountOfferEnabled = window.dazn.features.isEnabledAnonymous(
            'f_ppv_discount_offer'
        );

        return isPPVDiscountOfferEnabled;
    } catch (error) {
        return false;
    }
};

let ppvDiscountOfferValue: any;
export const getPPVDiscountOfferValue = () => {
    if (ppvDiscountOfferValue !== undefined) {
        return ppvDiscountOfferValue;
    }
    try {
        ppvDiscountOfferValue = JSON.parse(
            window.dazn.features.getVariableStringAnonymous(
                'f_ppv_discount_offer',
                'instalmentsBillingRate'
            )
        );
        return ppvDiscountOfferValue;
    } catch (error) {
        return {};
    }
};
export const isproductRedeemV2 = () => {
    const enabledPerProduct = JSON.parse(
        window.dazn.features.getVariableStringAuthenticated(
            'f_ar_product_redeem_gifcode_v2',
            'enablePerProductGroup'
        )
    );
    return enabledPerProduct?.['NFL'] || false;
};

export const getContentTierVersion = () => {
    return window.dazn.features.getVariableStringAnonymous(
            'f_ar_new_tierAccordianUi',
            'contentTierVersion'
        )
    ;
};

export {
    signinChapterData,
    signinChapterPath,
    exploreChapterData,
    exploreChapterPath,
    shouldSuperImpose,
    isPayopsOfferDetails,
    getpayopsOfferDetails
};
